"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveSubscriber = exports.SUBSCRIPTIONS_REMOVE_KEY = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const useSubscriptions_1 = require("./useSubscriptions");
exports.SUBSCRIPTIONS_REMOVE_KEY = 'remove_subscriber';
const useRemoveSubscriberApi = (referenceID) => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return async (body) => {
        const url = `${config.SUBSCRIPTIONS_ENDPOINT}/v2/subscriptions/remove/${referenceID}`;
        const response = await ui_platform_http_1.HttpBaseApi.post(url, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    };
};
const useRemoveSubscriber = (referenceID) => {
    const queryClient = (0, frontend_infra_reactquery_1.useQueryClient)();
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const removeSubscriberApi = useRemoveSubscriberApi(referenceID);
    return (0, frontend_infra_reactquery_1.useMutation)({
        mutationKey: [exports.SUBSCRIPTIONS_REMOVE_KEY],
        mutationFn: removeSubscriberApi,
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [useSubscriptions_1.SUBSCRIPTIONS_KEY] });
        },
        onError: (e) => {
            snackService.showError(e.message);
        },
    });
};
exports.useRemoveSubscriber = useRemoveSubscriber;
//# sourceMappingURL=useRemoveSubscriber.js.map